import axios from 'axios'
import config from '../config'
import {JsonHeaders} from '../constants'

export default {
    getFiles(type) {
        return axios.get(config.publicPath + 'upload_files', {
            params: {type: type},
            headers: JsonHeaders
        });
    },
}
